import ISensediaToken from "@/interfaces/ISensediaToken";
import sensediaService from "@/services/serviceSensedia";
import SecureLS from "secure-ls";
import { addMilliseconds } from "date-fns";

export function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
}

//Converte objeto para query params
export const ToQueryString = (params: any) => {
    const queryString = new URLSearchParams();
    let result = "";

    if (params) {
        for (let key in params) {
            let value = params[key];

            if (Array.isArray(value)) {
                for (let item of value) {
                    queryString.append(key, item);
                }
            } else {
                queryString.append(key, value);
            }
        }

        result = `?${queryString.toString()}`;
    }

    return result;
};

//Converte File para Base64 string
export const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve((reader.result as string).replace("data:application/pdf;base64,", ""));
        };

        reader.readAsDataURL(file);
        reader.onerror = reject;
    });

//Realiza o download do arquivo através do base64 string
//base64: base64 string de entrada
//saveAs: nome para salvar o arquivo
//type: Tipo de arquivo (pdf, csv, etc)
export function downloadFileFromBase64(base64: string, saveAs: string, type: string) {
    const linkSource = `data:application/${type};base64,${base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${saveAs}.${type}`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

// Limpa por completo o armazenamento do site: localStorage, sessionStorage,
// cookies e Cache Storage. Usado no "Entrar novamente" quando o carregamento
// do usuário falha, para garantir que a nova tentativa comece do zero.
export async function clearAllSiteData() {
    try {
        window.localStorage.clear();
    } catch (e) {
        /* storage indisponível */
    }
    try {
        window.sessionStorage.clear();
    } catch (e) {
        /* storage indisponível */
    }

    // Cookies — expira cada um no path atual e no domínio do host.
    try {
        document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            if (!name) return;
            const expira = `expires=${new Date(0).toUTCString()}`;
            document.cookie = `${name}=;${expira};path=/`;
            document.cookie = `${name}=;${expira};path=/;domain=${window.location.hostname}`;
        });
    } catch (e) {
        /* sem acesso a cookies */
    }

    // Cache Storage (assets de service worker / PWA).
    try {
        if (typeof caches !== "undefined") {
            const keys = await caches.keys();
            await Promise.all(keys.map((key) => caches.delete(key)));
        }
    } catch (e) {
        /* Cache API indisponível */
    }
}

export async function handleGetTokenSensedia() {
    var secStorage = new SecureLS({ encodingType: "aes" });

    //----Token Sensedia (conforme o ClientID)
    const clientIDAuth = process.env.REACT_APP_API_SENSEDIA_CLIENTID ?? "";
    const sensediaRedirectUri = process.env.REACT_APP_API_SENSEDIA_REDIRECT_URI ?? "";

    const objToken: ISensediaToken = {
        client_id: clientIDAuth,
        redirect_uri: sensediaRedirectUri,
        grant_type: "implicit",
    };

    const res = await sensediaService.getToken(objToken);

    if (res) {
        const obj = res.data.redirect_uri.split("=");
        const accessToken = obj[obj.length - 1];
        const expiresInSensedia = res?.data?.expires_in;

        const now = new Date();
        const expirationSensedia = addMilliseconds(now, expiresInSensedia);

        secStorage.set("access_token", accessToken);
        secStorage.set("expiration_sensedia", expirationSensedia);

        return accessToken;
    }
    return false;
}
